module.exports = __webpack_public_path__ + "6fae7e0500dd38bbba87ba6d02ecc2d7.svg";